import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { IWindowInfo } from "../../model/custom/ILayout";
import {
	CollapseSidebarAction,
	ExpandSidebarAction,
	ToggleSidebarAction,
	UpdateWindowInfoAction,
} from "./layout.actions";

export class LayoutStateModel {
	public isSidebarCollapsed: boolean;
	public isSidebarHidden: boolean;
	public windowInfo: IWindowInfo;
}

const { innerHeight: height, innerWidth: width } = window;
//  https://getbootstrap.com/docs/4.4/layout/overview/#responsive
export enum MediaQueryBreakpoints {
	extraSmall = 575.98,
	small = 767.98,
	medium = 991.98,
	large = 1199.98,
}

export const setWindowInfo = (innerHeight, innerWidth): IWindowInfo => {
	const { extraSmall, small, medium, large } = MediaQueryBreakpoints;
	return {
		height: innerHeight,
		width: innerWidth,
		isExtraSmall: innerWidth < extraSmall,
		isSmall: innerWidth < small && innerWidth > extraSmall,
		isMedium: innerWidth < medium && innerWidth > small,
		isLarge: innerWidth < large && innerWidth > medium,
		isExtraLarge: innerWidth > large,
		gtExtraSmall: innerWidth > extraSmall,
		gtLarge: innerWidth > large,
		gtMedium: innerWidth > medium,
		gtSmall: innerWidth > small,
		ltLarge: innerWidth < large,
		ltMedium: innerWidth < medium,
		ltSmall: innerWidth < small,
	};
};

@State<LayoutStateModel>({
	name: "layout",
	defaults: {
		isSidebarCollapsed: false,
		isSidebarHidden: false,
		windowInfo: setWindowInfo(height, width),
	},
})
@Injectable()
export class LayoutState {
	@Selector()
	static isSidebarCollapsed(state: LayoutStateModel): boolean {
		return state.isSidebarCollapsed;
	}

	@Selector()
	static isSidebarHidden(state: LayoutStateModel): boolean {
		return state.isSidebarHidden;
	}

	@Selector()
	static windowInfo(state: LayoutStateModel): IWindowInfo {
		return state.windowInfo;
	}

	@Action(CollapseSidebarAction)
	AuthUserLoginAction(ctx: StateContext<LayoutStateModel>) {
		ctx.patchState({
			isSidebarCollapsed: true,
			isSidebarHidden: false,
		});
	}

	@Action(ExpandSidebarAction)
	ExpandSidebarAction(ctx: StateContext<LayoutStateModel>) {
		ctx.patchState({
			isSidebarCollapsed: false,
			isSidebarHidden: false,
		});
	}

	@Action(ToggleSidebarAction)
	ToggleSidebarAction(
		ctx: StateContext<LayoutStateModel>,
		action: ToggleSidebarAction,
	) {
		ctx.patchState({
			isSidebarHidden: action.payload,
			isSidebarCollapsed: false,
		});
	}

	@Action(UpdateWindowInfoAction)
	UpdateWindowInfoAction(
		ctx: StateContext<LayoutStateModel>,
		action: UpdateWindowInfoAction,
	) {
		ctx.patchState({
			windowInfo: action.payload,
		});
	}
}
